<template>
  <div>
    <template v-if="$route.name === 'EXSBRefundUpdate'">
      <b-row>
        <b-col>
          <button v-if="prevRoute.name !== 'EXSBRefundList'" @click="$router.go(-1)" class="mb-1 btn btn-sm btn-default float-right">{{$t('buttons.goBack')}}</button>
          <router-link v-else :to="{ name: 'EXSBRefundList' }" class="mb-1 btn btn-sm btn-default float-right">{{$t('buttons.backToList')}}</router-link>
        </b-col>
      </b-row>
      <b-row v-if="!isLoading">
        <b-col>
          <div class="card">
            <div class="card-body">
              <b-row>
                <b-col>
                  <Form
                    :handle-submit="onSendForm"
                    :values="initialValues"
                    :violations="violations"/>
                </b-col>
              </b-row>
            </div>
          </div>
        </b-col>
      </b-row>
    </template>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { checkPagePermission } from '@/utils/checkRoles'
import Form from '@/components/Dashboard/Views/BusinessBundle/exsbrefund/Form.vue'

export default {
  name: 'Update',
  components: {
    Form
  },
  data () {
    return {
      prevRoute: {},
      displaySwitch: true,
      item: {}
    }
  },
  beforeRouteEnter (to, from, next) {
    next((vm) => {
      vm.prevRoute = from
    })
  },
  created () {
    this.retrieve(this.id)
  },
  watch: {
    updated (val) {
      if (val) {
        if (this.prevRoute.name !== 'EXSBRefundList') {
          this.$router.go(-1)
        } else {
          this.$router.push({ name: 'EXSBRefundList' })
        }
      }
    },
    retrieved (val) {
      this.item = JSON.parse(JSON.stringify(val))
      if (this.item.idClient && this.item.idClient['@id']) {
        this.item.idClient = this.item.idClient['@id']
      }
      if (this.item.idBankPayment && this.item.idBankPayment['@id']) {
        this.item.idBankPayment = this.item.idBankPayment['@id']
      }
      this.item.value = parseFloat(this.item.value).toFixed(2)
      this.originalData = JSON.parse(JSON.stringify(this.item))
    }
  },
  computed: {
    initialValues () {
      return this.item
    },
    id () {
      return this.$route.params.id
    },
    ...mapGetters({
      updated: 'exsbrefund/update/updated',
      retrieved: 'exsbrefund/show/retrieved',
      violations: 'exsbrefund/update/violations',
      isLoading: 'exsbrefund/show/isLoading'
    })
  },
  beforeCreate () {
    checkPagePermission('finances', 'EXSBRefundUpdate')
  },
  methods: {
    onSendForm () {
      this.update(this.item)
    },
    ...mapActions({
      update: 'exsbrefund/update/update',
      retrieve: 'exsbrefund/show/retrieve'
    }),
    cancelButton () {
      this.$router.go(-1)
    }
  }
}
</script>

<style scoped>

</style>
